import React from 'react';
import ReactDOM from 'react-dom';
import App from '@app/index';

import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import Loading from '@app/utils/Loading';
import { customAlphabet } from 'nanoid';
import { isObject, isEmpty } from 'lodash';
import { Toaster } from 'react-hot-toast';
import { deploymentModalKey } from '@app/pages/Deployments/Deployments';
import { API } from './api';

const nanoidDisplay = customAlphabet('1234567890abcdefghijklmnopqrstuvwxy', 10);

const apiUrl = process.env.API_URL || 'https://app.phasetwo.io';
export const baseUrl = `${apiUrl}/auth/realms`;

if (process.env.NODE_ENV !== 'production') {
  const config = {
    rules: [
      {
        id: 'color-contrast',
        enabled: false,
      },
    ],
  };
  // eslint-disable-next-line @typescript-eslint/no-var-requires, no-undef
  const axe = require('react-axe');
  axe(React, ReactDOM, 1000, config);
}

//      silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",

ReactDOM.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: 'login-required',
      checkLoginIframe: false,
    }}
    LoadingComponent={<Loading />}
    onEvent={async (eventType, error) => {
      if (eventType === 'onAuthLogout') {
        localStorage.removeItem(deploymentModalKey);
      }
      if (eventType === 'onAuthSuccess') {
        if (localStorage.getItem(deploymentModalKey) === null) {
          localStorage.setItem(deploymentModalKey, 'false');
        }

        // check for organizatons
        if (
          keycloak.tokenParsed &&
          'organizations' in keycloak.tokenParsed &&
          isObject(keycloak.tokenParsed?.organizations) &&
          isEmpty(keycloak.tokenParsed?.organizations)
        ) {
          const orgName = `org-${nanoidDisplay()}`;
          const displayName = `${keycloak.tokenParsed?.email} default`;
          const manageClustersRole: string = 'manage-clusters';
          var loc: string = '';
          try {
            API.Orgs.createOrg({
              name: orgName,
              displayName: displayName,
            })
              .then((resp) => {
                loc = resp.headers.get('Location') || '';
                loc = loc?.substring(loc.lastIndexOf('/') + 1);
                return API.Orgs.createRoleForOrg({ orgId: loc, roleName: manageClustersRole });
              })
              .then((resp) => {
                return API.Orgs.addUserToRole(keycloak.tokenParsed?.sub || '', loc, manageClustersRole);
              })
              .then((resp) => {
                keycloak.updateToken(-1).then((value) => {
                  console.log('Token is refreshed', value);
                });
              });
          } catch (e) {
            console.log('Error creating an organization.');
          }
        }
      }
    }}
  >
    <App />
    <Toaster toastOptions={{ duration: 8000 }} />
  </ReactKeycloakProvider>,
  document.getElementById('root') as HTMLElement
);
